export type ApiError = {
  data?: {
    [key: string]: string[];
  };
  statusCode: number;
};

export default function useApiError () {

  const fromError = (e: Error | unknown): ApiError | null => {
    if (e === null) {
      return null;
    }

    if (typeof e !== 'object') {
      return null;
    }

    if ('statusCode' in e) {
      return {
        statusCode: e.statusCode as number,
        data: (e as any).data,
      };
    }

    return null;
  };

  return {
    fromError,
  };

}